(() => {
  const initializeGallery = (gallery) => {
    if (gallery.dataset.tradeGalleryReady === 'true') return;

    const section = gallery.closest('section');
    const dialog = section?.querySelector('[data-trade-gallery-dialog]');
    const triggers = [...gallery.querySelectorAll('[data-trade-gallery-open]')];
    const image = dialog?.querySelector('[data-trade-gallery-image]');
    const heading = dialog?.querySelector('[data-trade-gallery-heading]');
    const text = dialog?.querySelector('[data-trade-gallery-text]');
    const counter = dialog?.querySelector('[data-trade-gallery-counter]');
    const closeButton = dialog?.querySelector('[data-trade-gallery-close]');
    const previousButton = dialog?.querySelector('[data-trade-gallery-previous]');
    const nextButton = dialog?.querySelector('[data-trade-gallery-next]');

    if (!dialog || !image || triggers.length === 0) return;

    gallery.dataset.tradeGalleryReady = 'true';
    let activeIndex = 0;
    let openingTrigger = null;

    const showImage = (index) => {
      activeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[activeIndex];
      image.src = trigger.dataset.gallerySrc || '';
      image.alt = trigger.dataset.galleryAlt || '';
      if (heading) heading.textContent = trigger.dataset.galleryHeading || trigger.dataset.galleryAlt || '';
      if (text) {
        text.textContent = trigger.dataset.galleryText || '';
        text.hidden = text.textContent === '';
      }
      if (counter) counter.textContent = `${activeIndex + 1} / ${triggers.length}`;
    };

    const openDialog = (trigger, index) => {
      openingTrigger = trigger;
      showImage(index);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      closeButton?.focus();
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => openDialog(trigger, index));
    });
    closeButton?.addEventListener('click', closeDialog);
    previousButton?.addEventListener('click', () => showImage(activeIndex - 1));
    nextButton?.addEventListener('click', () => showImage(activeIndex + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => openingTrigger?.focus());
  };

  const initialize = (root = document) => {
    if (root.matches?.('[data-trade-gallery]')) initializeGallery(root);
    root.querySelectorAll?.('[data-trade-gallery]').forEach(initializeGallery);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
